import {IoIosArrowBack} from "react-icons/io";
import React, {useEffect, useState} from "react";
import AddressModal from "../modal/AddressModal";
import AddressModalEdit from "../modal/AddressModalEdit";
import SingleAddressCard from "./SingleAddressCard";
import { IoMdClose } from "react-icons/io";
import { FiPlusCircle } from "react-icons/fi";

function AddressListModal({setRefreshAddresses, onClose, addresses, setSelected, selected, setDefaultAddress}) {

    const [currentAddress, setCurrentAddress] = useState(null)
    const [selectedAddressId, setSelectedAddressId] = useState("")

    const changeAddress = () => {
        if(currentAddress) {
            console.log(selected)
            console.log(currentAddress)
            setDefaultAddress(currentAddress)
            setSelected(currentAddress?._id)
        }
        onClose()
    }

    const openEditModal = (item) => {
        setSelectedAddressId(item?._id);
    }

    useEffect(() => {
        console.log(selected)
    },[])

    return (
        <>
            <div className="full-screen-modal">
                <div className="modal-header d-flex flex-column align-items-center gap-2">
                <div className="d-flex align-items-center justify-content-between w-100">
                    <h5 className="header-text mb-0 mx-auto">SELECT AN ADDRESS</h5>
                    <IoMdClose onClick={onClose} className="back-icon position-absolute end-0 me-3" />
                </div>
                <button
                    style={{
                        background: "none",
                        color: "#8B4513",
                        border: "none",
                        padding: 0,
                        fontWeight: 500,
                        fontSize: "0.95rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#addressModal"
                >
                    <span style={{ fontSize: "1.2rem" }}><FiPlusCircle /></span> Add Address
                </button>
            </div>

                <div className="coupon-body">
                    <h6>Saved Address</h6>
                    <div className="coupon-section">
                        {addresses?.map((item, i) => (
                            <SingleAddressCard item={item} openEditModal={openEditModal} selected={selected}
                                               setRefreshAddresses={setRefreshAddresses}
                                               setCurrentAddress={setCurrentAddress}/>
                        ))}
                    </div>
                    <br/>
                    <button type="button" className="submit-button" onClick={() => changeAddress()}>Use this Address</button>
                </div>
            </div>
            <AddressModal setRefreshAddresses={setRefreshAddresses}/>
            <AddressModalEdit
                setRefreshAddresses={setRefreshAddresses}
                addressId={selectedAddressId}
            />
        </>
    )
}

export default AddressListModal